import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MusicDataService } from '../music-data.service';
import { DeezerLinkComponent } from '../shared/deezer-link.component';
import { FavouriteArtistsService } from '../favourite-artists.service';
import { FavouriteHeartComponent } from '../shared/favourite-heart.component';
import { PlayerModeToggleComponent } from '../shared/player-mode-toggle.component';
import { TrackPlayerComponent } from '../shared/track-player.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-song-search-result',
  templateUrl: './song-search-result.component.html',
  styleUrls: ['./song-search-result.component.css'],
  imports: [RouterLink, MatCard, MatCardContent, MatIcon, MatIconButton, DeezerLinkComponent, PlayerModeToggleComponent, TrackPlayerComponent, FavouriteHeartComponent]
})
export class SongSearchResultComponent implements OnInit, OnDestroy {
  results = signal<any[]>([]);
  searchQuery = signal('');
  loading = signal(false);

  private qSub?: Subscription;
  private searchSub?: Subscription;
  private addFavSub?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private data: MusicDataService,
    private snackBar: MatSnackBar,
    protected artistFavourites: FavouriteArtistsService
  ) { }

  ngOnInit() {
    this.artistFavourites.ensureIds();
    this.qSub = this.route.params.subscribe(params => {
      this.searchQuery.set(params['id']);
      this.loading.set(true);
      this.searchSub?.unsubscribe();
      this.searchSub = this.data.searchTracks(params['id']).subscribe({
        next: (d) => {
          this.results.set(d.tracks.items);
          this.loading.set(false);
        },
        error: (err) => {
          console.error('Song search error:', err);
          this.results.set([]);
          this.loading.set(false);
        }
      });
    });
  }

  addFavourite(track: any): void {
    this.addFavSub?.unsubscribe();
    this.addFavSub = this.data.addToFavourites(track.id).subscribe({
      next: () => this.snackBar.open('Added to Favourites!', 'OK', { duration: 2000 }),
      error: (err) => {
        console.error('Error adding to favourites:', err);
        this.snackBar.open('Unable to Add to Favourites: ' + (err.message || 'Unknown error'), 'Error', { duration: 3000 });
      }
    });
  }

  ngOnDestroy() {
    this.qSub?.unsubscribe();
    this.searchSub?.unsubscribe();
    this.addFavSub?.unsubscribe();
  }
}
